import { majorApi } from '../../../services';
import {
	createStatsQueryHook,
	createChartQueryHook,
	type StatsQueryParams,
	type ChartQueryParams,
} from '../../../hooks';

export type UseMajorsQueryParams = StatsQueryParams;
export type UseMajorsChartParams = ChartQueryParams;

/** Majors include maTinh filter in stats queries */
const MAJOR_FILTER_KEYS = ['query', 'years', 'maKhoa', 'maNganh', 'maTinh'] as const;

export const useMajorsQuery = createStatsQueryHook({
	entityKey: 'majors',
	apiFn: (params) => majorApi.getMajorStats(params),
	filterKeys: MAJOR_FILTER_KEYS,
});

export const useMajorsChartQuery = createChartQueryHook({
	entityKey: 'majors',
	apiFn: (params) => majorApi.getNivoLineChartData(params),
});
